// extracted by mini-css-extract-plugin
export default {"img":"LevelImage_img__oarAg","container":"LevelImage_container__qE5W2"};